module.exports = __webpack_public_path__ + "img/73.770e66e2.jpg";